import React, { useState, useEffect } from 'react';
import { Star, MessageSquareQuote, User } from 'lucide-react';
import api from '../../api/axios';

const ReviewsPage = () => {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const response = await api.get('/public-reviews');
                const raw = response.data?.data || response.data;
                setReviews(Array.isArray(raw) ? raw : []);
            } catch (error) {
                console.error("Error al cargar las reseñas:", error);
                setReviews([]);
            } finally {
                setLoading(false);
            }
        };
        fetchReviews();
    }, []);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center font-black text-[#CE010B] animate-pulse uppercase tracking-widest">
                CARGANDO OPINIONES...
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-transparent py-16 px-4 md:px-8">
            <div className="w-3/4 mx-auto lg:w-full lg:max-w-6xl space-y-12">

                {/* ENCABEZADO */}
                <div className="text-center space-y-4">
                    <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter text-white dark:text-white">
                        Opiniones <span className="text-white underline decoration-[#CE010B] decoration-4 underline-offset-[8px]">Reales</span>
                    </h1>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {(Array.isArray(reviews) ? reviews : []).map((review) => (
                        <div 
                            key={review.id} 
                            // --- ESTA ES LA PARTE QUE DEFINE LOS COLORES ---
                            className="p-10 lg:p-8 rounded-[2.5rem] shadow-2xl relative group overflow-hidden border border-black/5 dark:border-white/10
                                       bg-[linear-gradient(180deg,#F1F1F1_0%,#C1C1C1_100%)] 
                                       dark:bg-[linear-gradient(180deg,#590000_0%,#780000_100%)]"
                            // ----------------------------------------------
                        >
                            <MessageSquareQuote className="absolute top-6 right-6 text-black/10 dark:text-white/10" size={60} />

                            <div className="space-y-6 relative z-10">
                                <div className="flex items-center gap-4">
                                    <div className="w-16 h-16 lg:w-12 lg:h-12 bg-black/10 dark:bg-black/30 rounded-full flex items-center justify-center text-black dark:text-white">
                                        <User className="w-8 h-8 lg:w-6 lg:h-6" />
                                    </div>
                                    <div>
                                        <p className="font-black text-3xl lg:text-lg uppercase text-black dark:text-white">
                                            {review.user?.name || 'Socio Anónimo'}
                                        </p>
                                        {review.created_at && (
                                            <p className="text-gray-500 dark:text-white/40 text-lg lg:text-[11px] font-bold mt-0.5">
                                                {new Date(review.created_at).toLocaleDateString('es-ES', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric'
                                                })}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="flex gap-1">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <Star 
                                            key={star} 
                                            className={`w-8 h-8 lg:w-4.5 lg:h-4.5 ${star <= review.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-400'}`} 
                                        />
                                    ))}
                                </div>

                                <p className="text-gray-900 dark:text-white italic text-2xl lg:text-sm font-normal leading-relaxed">
                                    "{review.comment}"
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ReviewsPage;